import React from 'react';
import { Box } from '@mui/material';
import AffidavitListHeader from './AffidavitListHeader';
import AffidavitListItems from './AffidavitListItems';

function AffidavitList({ title, items, onDelete, onPrint }) {
  return (
    <Box className="affidavit-list-container bg-white mb-4">
      {/* Header component */}
      <AffidavitListHeader title={title} />
      
      {/* Items component */}
      <AffidavitListItems 
        items={items} 
        onDelete={onDelete} 
        onPrint={onPrint} 
      />
    </Box>
  );
}

export default AffidavitList; 